export enum WorkflowEditorMode {
  EDIT = 'edit',
  CREATE = 'create',
}

export interface WorkflowV2EditorProps {
  editorMode?: WorkflowEditorMode
}
